import { api } from "@/lib/api";
import { toast } from "sonner";

const ensureSession = () => api.get("/auth/me").then(() => true)
  .catch(() => api.post("/auth/refresh").then(() => true).catch(() => false));

const sessionExpired = () => {
  toast.error("Sessione scaduta: accedi di nuovo per aprire il documento");
  setTimeout(() => { window.location.href = "/login"; }, 1200);
};

export function openSecure(url) {
  const w = window.open("", "_blank");
  ensureSession().then((ok) => {
    if (!ok) { if (w) { w.close(); } sessionExpired(); return; }
    if (w) { w.location.href = url; } else { window.location.href = url; }
  });
}

export function downloadSecure(url) {
  ensureSession().then((ok) => {
    if (!ok) { sessionExpired(); return; }
    const a = document.createElement("a");
    a.href = url;
    document.body.appendChild(a);
    a.click();
    a.remove();
  });
}

export const secureClick = (url, download = false) => (e) => {
  e.preventDefault();
  if (download) { downloadSecure(url); } else { openSecure(url); }
};
